/**
 * @file Created on Mon Aug 13 2018
 * @author PKl
 */
import Notice from './Notice';
export default Notice;